import ResultsServiceModel from '@/models/ResultsServiceModel'

export default class IntegrationModel extends ResultsServiceModel {
  modelName () {
    return 'integrations'
  }

  defaults () {
    return {
      id: null,
      type: null,
      name: null,
      description: null,
      singleton: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      type: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val),
      singleton: val => (typeof val === 'number' ? val : (val === null || val === undefined ? null : Boolean(val))),
      created_at: val => (val ? this.nullStringMutator(val) : undefined),
      updated_at: val => (val ? this.nullStringMutator(val) : undefined),
      deleted_at: val => (val ? this.nullStringMutator(val) : undefined),
    };
  }
}
